export default "__VITE_ASSET__Gr7VD1tl__"